import * as E from 'fp-ts/Either';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
import * as t from 'io-ts';
import { NonEmptyString, option } from 'io-ts-types';
export var optionNonEmptyString = new t.Type('optionNonEmptyString', option(NonEmptyString).is, function (u, c) {
    return pipe(t.string.validate(u, c), E.chain(function (str) { return pipe(NonEmptyString.validate(str, c), O.fromEither, t.success); }));
}, O.getOrElse(function () { return ''; }));
